<template>
<div :aria-busy="loading ? 'true' : 'false'">
	<div v-if="!loading">
	<alert :conditional="user.fb_page_id === null && user.organization.is_mandatoaberto !== 0"
		:classFather="'alert'"
		:message="'alert-facebook'"
		:iconClass="'icon fas fa-warning'"
		:linkShow="false"
		:close-button="true">
	</alert>

	<section class="content__custom">
		<div class="main-title" >
				<h1 class="profile">
					{{ 'menuConfig' | translate | titleCase }}
				</h1>
		</div>
		<div class="boxes">
				<facebook v-if="1 !== 1"></facebook>
				<ticketsConfig v-if="hasTickets"></ticketsConfig>
				<dialogs v-if="dialogs"></dialogs>
		</div>
	</section>
	</div>
</div>
</template>
<script>
	import alert from '../../components/alert/alert.vue';
	import user from './user.vue';
	import facebook from './facebook.vue';
	import contact from './contact.vue';
	import greeting from './greeting.vue';
	import dialogs from './dialogs.vue';
	import ticketsConfig from './ticketsConfig.vue';


	export default {
		name: 'profile',
		components: {
			alert,
			user,
			facebook,
			contact,
			greeting,
			dialogs,
			ticketsConfig,
		},
		data() {
			return {
				session: {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
				},
				loading: false,
			};
		},
		computed: {
			user() {
				return this.$store.state.user;
			},
			dialogs() {
				return this.$store.state.profile.dialog.dialogs;
			},
			hasTickets() {
				return this.user.organization.has_ticket;
			},
		},
		methods: {
			toggleLoading() {
				this.loading = !this.loading;
			},
			getDialog() {
				this.toggleLoading();
				this.$store.dispatch('getDialog', this.session)
					.then(() => {
						this.toggleLoading();
					})
					.catch(() => {
						this.toggleLoading();
					});
			},
		},
		mounted() {
			this.getDialog();
		},
	};
</script>





// WEBPACK FOOTER //
// _source/javascripts/modules/profile/profile.vue